import {MvsCrudService} from "../../../../../core/shared/service/crud/mvs-crud.service";
import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ConfirmationService} from "primeng/api";
import {CustomerContractService} from "../../../service/api/customer-contract.service";
import {CustomerContractDto} from "../../../model/dto/entity/customer-contract.dto";
import {CustomerEntityAssignmentType} from "../../../enum/customer-entity-assignment-type.enum";
import {Router} from "@angular/router";
import {ContractDto} from "../../../../cm/model/dto/entity/contract.dto";
import {ContractFormerDto} from "../../../../cm/model/dto/entity/contract-former.dto";
import {ContractFormerContractEnum} from "../../../../cm/enum/contract-former-contract-enum.enum";
import {ContractStatusDto} from "../../../../cm/model/dto/entity/contract-status.dto";
import {ObjectBaseComponent} from "../../../../../core/shared/object/mvs-object-base/object-base.component";
import {ObjectIdentifier} from "../../../../../core/shared/basic/object-identifier";
import {MvsCoreService} from "../../../../../core/shared/service/mvs-core.service";
import {MvsMessageService} from "../../../../../core/shared/service/message/mvs-message.service";
import {ObserverService} from "../../../../../core/shared/object/service/observer.service";
import {
    ObjectChangeInformation,
    ObjectChangeInformationActionEnum
} from "../../../../../core/shared/logic/object-change-information";
import {EntityStatusEnum} from "../../../../../core/shared/entity/enum/entity-status.enum";

// NOT_IN_USE
@Component({
    selector: 'cr-create-customer-contract',
    templateUrl: './cr-create-customer-contract.component.html',
    standalone: false
})
export class CrCreateCustomerContractComponent extends ObjectBaseComponent implements OnInit, OnChanges, OnDestroy {

    contractStatusService: MvsCrudService;
    contractFormerService: MvsCrudService;
    @Input() customerId: number;
    @Input() formerContract: ContractDto;

    createdObjectIdentifier: ObjectIdentifier;
    createdContract: ContractDto;


    constructor(
        protected coreService: MvsCoreService,
        protected confirmationService: ConfirmationService,
        protected customerContractService: CustomerContractService,
        protected router: Router,
        protected messageService: MvsMessageService,
        protected override observerService: ObserverService) {

        super(coreService, messageService, confirmationService, observerService);


        this.contractStatusService = this.coreService.getCrudService("cm.ContractStatus");
        this.contractFormerService = this.coreService.getCrudService("cm.ContractFormer");
    }

    ngOnInit(): void {
        super.ngOnInit();

        this.initialized = true;

    }

    ngOnChanges(changes: SimpleChanges): void {

        super.ngOnChanges(changes);

        if (!this.initialized) {
            return;
        }

    }


    /**
     * On Object Change.
     */
    onObjectChanged() {

    }

    handleObject(event: ObjectChangeInformation) {

        if (event.action == ObjectChangeInformationActionEnum.created) {
            this.createdObjectIdentifier = new ObjectIdentifier(event.objectType, event.after.id);
            this.createdContract = <ContractDto>event.after;
            this.createCustomerContract(this.createdObjectIdentifier);
            this.createContractStatus();
        } else {
            this.messageService.showWarningMessage("Info", "Vertrag wurde bereits angelegt und zugewiesen, bitte mit der Bearbeitung auf der Vertragsseite weitermachen.");
        }


    }

    createCustomerContract(objectIdentifier: ObjectIdentifier) {

        const customerContractDto = new CustomerContractDto();
        customerContractDto.customerDtoId = this.customerId;
        customerContractDto.contractDtoId = objectIdentifier.objectId;
        customerContractDto.assignmentType = CustomerEntityAssignmentType.main;
        customerContractDto.entityStatus = EntityStatusEnum.active;

        this.customerContractService.create(customerContractDto).subscribe((res: CustomerContractDto) => {

            if (this.formerContract) {
                this.assignFormerContract(objectIdentifier);
            }


            this.navigateToCustomerContract(res);
        })
    }

    assignFormerContract(objectIdentifier: ObjectIdentifier) {

        const dto = new ContractFormerDto();
        dto.contractDtoId = objectIdentifier.objectId;
        dto.assignment = ContractFormerContractEnum.change;
        dto.contractFormerDtoId = this.formerContract.id;

        this.contractFormerService.create(dto).subscribe(res => {
        })
    }

    createContractStatus() {

        const contractStatusDto = new ContractStatusDto();
        contractStatusDto.startDate = this.createdContract.startDate;
        contractStatusDto.contractDtoId = this.createdContract.id;
        //statusTypeDtoId 1 = Hauptstatus and statusTypeEntryDtoId 2 = active / draft
        contractStatusDto.statusTypeDtoId = 1;
        contractStatusDto.statusTypeEntryDtoId = 1;

        this.contractStatusService.create(contractStatusDto).subscribe(res => {
        })


    }

    navigateToCustomerContract(dto: CustomerContractDto) {
        const event = new ObjectChangeInformation();
        event.after = dto;
        this.onChangedObject.emit(event);
        this.router.navigateByUrl("/cm/contract/" + this.createdObjectIdentifier.objectId);

    }

}
